export const GOV_SA_EN = {
    // ── gov-sa/qiwa: the labour-platform worklist (#61) ──
    "nav.module.qiwa": "Qiwa",
    "nav.qiwa.worklist": "Qiwa worklist",
    "gov_sa.qiwa.worklist.screen.title": "Qiwa worklist",
    "gov_sa.qiwa.worklist.screen.lede": "Contract and transfer tasks done on Qiwa, recorded here and checked by another.",
    "gov_sa.qiwa.worklist.col.employee": "Employee",
    "gov_sa.qiwa.worklist.col.employee_number": "Employee number",
    "gov_sa.qiwa.worklist.col.kind": "To do",
    "gov_sa.qiwa.worklist.col.effective_on": "From",
    "gov_sa.qiwa.worklist.col.days_since": "Days since",
    "gov_sa.qiwa.worklist.col.status": "Status",
    "gov_sa.qiwa.worklist.col.reference": "Qiwa reference",
    "gov_sa.qiwa.worklist.col.last_failure": "Refused by the platform",
    "gov_sa.qiwa.worklist.col.failed_on": "Refused on",
    "gov_sa.qiwa.worklist.col.transfer_from": "Transferred from",
    "gov_sa.qiwa.worklist.col.can_refuse": "You may record a refusal",
    "gov_sa.qiwa.worklist.col.done_on": "Done on",
    "gov_sa.qiwa.worklist.col.contract_version": "Contract version",
    "gov_sa.qiwa.worklist.col.recorded_by_me": "Recorded by you",
    "gov_sa.qiwa.worklist.col.about_me": "About you",
    "gov_sa.qiwa.worklist.col.employment_id": "Employment",
    "gov_sa.qiwa.worklist.col.can_record": "You may record this",
    "gov_sa.qiwa.worklist.col.can_check": "You may check this",
    "gov_sa.qiwa.worklist.col.can_send_back": "You may send this back",
    "gov_sa.qiwa.worklist.col.can_withdraw": "You may withdraw this",
    "gov_sa.qiwa.kind.attest_contract": "Attest the contract",
    "gov_sa.qiwa.kind.update_contract": "Update the contract",
    "gov_sa.qiwa.kind.end_relation": "Close the relation",
    "gov_sa.qiwa.kind.transfer_service": "Transfer the service",
    "gov_sa.qiwa.kind.verify_employee": "Verify the employee's data",
    "gov_sa.qiwa.status.to_do": "To do",
    "gov_sa.qiwa.status.recorded": "Waiting to be checked",
    "gov_sa.qiwa.status.done": "Done",
    "gov_sa.qiwa.status.withdrawn": "Withdrawn",
    "gov_sa.qiwa.worklist.stat.open": "To do on Qiwa",
    "gov_sa.qiwa.worklist.stat.recorded": "Waiting to be checked",
    "gov_sa.qiwa.worklist.action.refresh": "Refresh from HR",
    "gov_sa.qiwa.worklist.action.open_transfer": "Open a service transfer",
    "gov_sa.qiwa.worklist.action.open_transfer.field.employment_id.help": "Everyone not known to be a citizen. Refresh from HR if the person is missing.",
    "gov_sa.qiwa.worklist.action.open_transfer.field.transfer_from.help": "The establishment the service comes from, as the platform names it.",
    "gov_sa.qiwa.worklist.action.refused": "Refused by the platform",
    "gov_sa.qiwa.worklist.action.refused.field.reason": "What the platform said",
    "gov_sa.qiwa.channel.not_configured": "The labour platform is not connected: the settings the authority gives have not been provided.",
    "gov_sa.qiwa.channel.no_adapter": "The labour platform is not connected yet: the link with Qiwa has not been set up.",
    "gov_sa.muqeem.channel.not_configured": "Muqeem is not connected: the settings the authority gives have not been provided.",
    "gov_sa.muqeem.channel.no_adapter": "Muqeem is not connected yet: the link with Muqeem has not been set up.",
    "gov_sa.qiwa.worklist.action.record": "Record the Qiwa reference",
    "gov_sa.qiwa.worklist.action.record.field.reference.help": "The number the platform gave the transaction. Somebody else checks it before it counts.",
    "gov_sa.qiwa.worklist.action.check": "Checked on Qiwa",
    "gov_sa.qiwa.worklist.action.send_back": "Send back",
    "gov_sa.qiwa.worklist.action.withdraw": "Nothing to do",
    "gov_sa.refusal.qiwa.item_not_open": "Only an item still to do is changed this way (it is {status}).",
    "gov_sa.refusal.qiwa.item_not_recorded": "Only a recorded item is checked or sent back (it is {status}).",
    "gov_sa.refusal.qiwa.own_record": "Whoever recorded it does not check it; somebody else does.",
    "gov_sa.refusal.qiwa.about_self": "This is about your own employment; somebody else decides it.",
    "gov_sa.refusal.qiwa.subject_unknown": "Who this is about is not known here yet, so it cannot be told it is not you. Refresh from HR first.",
    "gov_sa.refusal.qiwa.employment_unknown": "This employment is not known here yet. Refresh from HR first.",
    "gov_sa.refusal.qiwa.citizen_transfer": "A citizen's service is not transferred on this worklist.",
    "gov_sa.refusal.qiwa.transfer_open": "A service transfer is already open for this employee.",
    "gov_sa.refusal.qiwa.not_connected": "The labour platform is not connected, so nothing was sent. Do it on the platform and record its reference.",
    // ── gov-sa/mudad: the payroll run's WPS page and card (WPS decision: mudad owns the bank file) ──
    "gov_sa.mudad.run.title": "Payroll run (WPS)",
    "gov_sa.mudad.run.col.period": "Payroll period",
    "gov_sa.mudad.run.col.kind": "Run kind",
    "gov_sa.mudad.run.col.status": "Run status",
    "gov_sa.mudad.run.col.salary_file": "WPS file",
    "gov_sa.mudad.run.col.pay_date": "Pay day",
    "gov_sa.mudad.run.col.due_on": "Upload to Mudad by",
    "gov_sa.mudad.run.col.stage": "WPS clock",
    "gov_sa.mudad.run.col.employees": "Employees",
    "gov_sa.mudad.run.col.hr_state": "Payroll answered",
    "gov_sa.mudad.run.kind.main": "Main",
    "gov_sa.mudad.run.kind.supplementary": "Supplementary",
    "gov_sa.mudad.run.kind.settlement": "Final settlement",
    "gov_sa.mudad.run.status.approved": "Approved",
    "gov_sa.mudad.run.status.paid": "Paid",
    "gov_sa.mudad.run.status.locked": "Locked",
    "gov_sa.mudad.run.salary_file.not_generated": "No file written yet",
    "gov_sa.mudad.run.salary_file.generated": "Written, not uploaded",
    "gov_sa.mudad.run.salary_file.uploaded": "Uploaded to Mudad",
    "gov_sa.mudad.run.salary_file.status_imported": "Status report imported",
    "gov_sa.mudad.run.title_template": "Payroll run {period} on Mudad",
    "gov_sa.mudad.run.subtitle.pay_date": "Paid on {value}",
    "gov_sa.mudad.run.subtitle.employees": "{value} employees",
    "gov_sa.mudad.run.monogram": "WP",
    "gov_sa.mudad.run.alert.overdue": "The WPS file of this run is past its upload window ({stage})",
    "gov_sa.mudad.run.alert.due": "Upload the WPS file to Mudad by {due_on}",
    "gov_sa.mudad.run.alert.hr_silent": "Payroll did not answer: what is shown is what this unit heard of the run, not payroll's own row",
    "gov_sa.mudad.run_wps.title": "Wage protection (Mudad)",
    "gov_sa.mudad.run_wps.col.salary_file": "WPS file",
    "gov_sa.mudad.run_wps.col.salary_filename": "File",
    "gov_sa.mudad.run_wps.col.direct_file": "Direct-transfer list",
    "gov_sa.mudad.run_wps.col.due_on": "Upload to Mudad by",
    "gov_sa.mudad.run_wps.col.days_left": "Days left",
    "gov_sa.mudad.run_wps.col.stage": "WPS clock",
    "gov_sa.mudad.run_wps.col.exposure": "Fine if still late",
    "gov_sa.mudad.run_wps.col.paid": "Paid per Mudad's report",
    "gov_sa.mudad.run_wps.col.rejected": "Rejected",
    "gov_sa.mudad.run_wps.col.pending": "Pending",
    "gov_sa.mudad.run_wps.col.settlements": "Final settlements paid by this run",
    "gov_sa.mudad.run_wps.link": "WPS files",
    "gov_sa.mudad.run_wps.note": "The file is written, uploaded and its report imported on the WPS files screen. Nothing here talks to Mudad or a bank.",
    // ── gov-sa/muqeem: residences and visas (#62) ──
    "nav.module.muqeem": "Muqeem",
    "nav.muqeem.worklist": "Visas (Muqeem)",
    "nav.muqeem.residences": "Residences",
    "gov_sa.muqeem.worklist.screen.title": "Visas (Muqeem)",
    "gov_sa.muqeem.worklist.screen.lede": "Visa and transfer tasks done on Muqeem, recorded here and checked by another.",
    "gov_sa.muqeem.worklist.col.employee": "Employee",
    "gov_sa.muqeem.worklist.col.employee_number": "Employee number",
    "gov_sa.muqeem.worklist.col.kind": "To obtain",
    "gov_sa.muqeem.worklist.col.from_on": "Leave from",
    "gov_sa.muqeem.worklist.col.to_on": "Leave to",
    "gov_sa.muqeem.worklist.col.effective_on": "Needed by",
    "gov_sa.muqeem.worklist.col.days_until": "Days left",
    "gov_sa.muqeem.worklist.col.status": "Status",
    "gov_sa.muqeem.worklist.col.reference": "Visa number",
    "gov_sa.muqeem.worklist.col.issued_on": "Issued on",
    "gov_sa.muqeem.worklist.col.valid_until": "Valid until",
    "gov_sa.muqeem.worklist.col.leave_type": "Leave type",
    "gov_sa.muqeem.worklist.col.transfer_from": "Transferred from",
    "gov_sa.muqeem.worklist.col.recorded_by_me": "Recorded by you",
    "gov_sa.muqeem.worklist.col.about_me": "About you",
    "gov_sa.muqeem.worklist.col.employment_id": "Employment",
    "gov_sa.muqeem.worklist.col.can_record": "You may record this",
    "gov_sa.muqeem.worklist.col.can_check": "You may check this",
    "gov_sa.muqeem.worklist.col.can_send_back": "You may send this back",
    "gov_sa.muqeem.worklist.col.can_withdraw": "You may withdraw this",
    "gov_sa.muqeem.kind.exit_reentry": "Exit / re-entry",
    "gov_sa.muqeem.kind.final_exit": "Final exit",
    "gov_sa.muqeem.kind.sponsorship_transfer": "Sponsorship transfer",
    "gov_sa.muqeem.status.waiting": "Citizenship not known yet",
    "gov_sa.muqeem.status.to_do": "To obtain",
    "gov_sa.muqeem.status.recorded": "Waiting to be checked",
    "gov_sa.muqeem.status.done": "Done",
    "gov_sa.muqeem.status.withdrawn": "Withdrawn",
    "gov_sa.muqeem.worklist.stat.to_do": "Visas to obtain",
    "gov_sa.muqeem.worklist.stat.recorded": "Waiting to be checked",
    "gov_sa.muqeem.worklist.stat.waiting": "Citizenship not known yet",
    "gov_sa.muqeem.worklist.action.refresh": "Refresh from HR",
    "gov_sa.muqeem.worklist.action.open_transfer": "Open a sponsorship transfer",
    "gov_sa.muqeem.worklist.action.open_transfer.field.employment_id.help": "Everyone not known to be a citizen. Refresh from HR if the person is missing.",
    "gov_sa.muqeem.worklist.action.open_transfer.field.transfer_from.help": "The establishment the sponsorship comes from, as the platform names it.",
    "gov_sa.muqeem.worklist.action.record": "Record the visa",
    "gov_sa.muqeem.worklist.action.record.field.reference.help": "The number the platform gave the visa. Somebody else checks it before it counts.",
    "gov_sa.muqeem.worklist.action.check": "Checked on Muqeem",
    "gov_sa.muqeem.worklist.action.send_back": "Send back",
    "gov_sa.muqeem.worklist.action.withdraw": "No visa needed",
    "gov_sa.muqeem.residences.screen.title": "Residences",
    "gov_sa.muqeem.residences.screen.lede": "Every non-citizen's residence permit, its number from HR and its expiry from the latest renewed document.",
    "gov_sa.muqeem.residences.col.employee": "Employee",
    "gov_sa.muqeem.residences.col.employee_number": "Employee number",
    "gov_sa.muqeem.residences.col.residence_number": "Residence number",
    "gov_sa.muqeem.residences.col.expires_on": "Expires on",
    "gov_sa.muqeem.residences.col.days_left": "Days left",
    "gov_sa.muqeem.residences.col.standing": "Standing",
    "gov_sa.muqeem.residences.col.renewed_on": "Renewed on",
    "gov_sa.muqeem.residences.col.employment_status": "Employment status",
    "gov_sa.muqeem.residences.col.employment_id": "Employment",
    "gov_sa.muqeem.residences.col.document_id": "Document",
    "gov_sa.muqeem.standing.valid": "Valid",
    "gov_sa.muqeem.standing.expiring": "Expiring soon",
    "gov_sa.muqeem.standing.expired": "Expired",
    "gov_sa.muqeem.standing.unknown": "No expiry known",
    "gov_sa.muqeem.residences.stat.expiring": "Expiring soon",
    "gov_sa.muqeem.residences.stat.expired": "Expired",
    "gov_sa.muqeem.residences.stat.unknown": "No expiry known",
    "gov_sa.muqeem.residences.action.settings": "Residence settings",
    "gov_sa.muqeem.residences.field.residence_type_keys": "Document types that are a residence permit",
    "gov_sa.muqeem.residences.field.residence_type_keys.help": "The catalogue keys of the document types, separated by commas — as this workspace wrote them (iqama, residence_permit, residence by default).",
    "gov_sa.muqeem.residences.field.expiry_warning_days": "Warn this many days before expiry",
    "gov_sa.muqeem.residences.field.expiry_warning_days.help": "Empty keeps the current value (90 by default).",
    "gov_sa.refusal.muqeem.item_not_open": "Only a visa still to obtain is changed this way (it is {status}).",
    "gov_sa.refusal.muqeem.item_not_recorded": "Only a recorded visa is checked or sent back (it is {status}).",
    "gov_sa.refusal.muqeem.own_record": "Whoever recorded it does not check it; somebody else does.",
    "gov_sa.refusal.muqeem.about_self": "This is about your own employment; somebody else decides it.",
    "gov_sa.refusal.muqeem.subject_unknown": "Who this is about is not known here yet, so it cannot be told it is not you. Refresh from HR first.",
    "gov_sa.refusal.muqeem.employment_unknown": "This employment is not known here yet. Refresh from HR first.",
    "gov_sa.refusal.muqeem.citizen_no_sponsor": "A citizen has no sponsor to transfer.",
    "gov_sa.refusal.muqeem.transfer_open": "A sponsorship transfer is already open for this employee.",
    "gov_sa.refusal.muqeem.valid_before_issued": "A visa is not valid before the day it was issued ({issued_on}).",
    "gov_sa.refusal.muqeem.type_key": "A document type key is lower-case letters, digits, dot, dash or underscore ({key}).",
    // ── gov-sa/nitaqat: the Saudization ratio (#63) ──
    "nav.module.nitaqat": "Nitaqat",
    "nav.nitaqat.ratio": "Saudization ratio",
    "nav.nitaqat.minimum_wages": "Nitaqat minimum wage",
    "nav.nitaqat.bands": "Nitaqat bands",
    "gov_sa.nitaqat.ratio.screen.title": "Saudization ratio",
    "gov_sa.nitaqat.ratio.screen.lede": "The Saudization ratio each time it moved, newest first, with its band; the thresholds are settings ⚠ to confirm.",
    "gov_sa.nitaqat.ratio.col.as_of": "As of",
    "gov_sa.nitaqat.ratio.col.computed_at": "Computed",
    "gov_sa.nitaqat.ratio.col.ratio": "Ratio",
    "gov_sa.nitaqat.ratio.col.band": "Band",
    "gov_sa.nitaqat.ratio.col.gap": "Above the floor",
    "gov_sa.nitaqat.ratio.col.next_band": "Next band",
    "gov_sa.nitaqat.ratio.col.next_min_ratio": "Next band from",
    "gov_sa.nitaqat.ratio.col.saudis_counted": "Citizens counted",
    "gov_sa.nitaqat.ratio.col.saudis_total": "Citizens in service",
    "gov_sa.nitaqat.ratio.col.non_saudis": "Non-citizens",
    "gov_sa.nitaqat.ratio.col.saudis_below_wage": "Below the minimum wage",
    "gov_sa.nitaqat.ratio.col.saudis_unregistered": "Not registered with GOSI",
    "gov_sa.nitaqat.ratio.col.saudis_unattested": "Contract not attested",
    "gov_sa.nitaqat.ratio.col.unknown_citizenship": "Citizenship not known",
    "gov_sa.nitaqat.ratio.col.minimum_wage": "Minimum wage applied",
    "gov_sa.nitaqat.ratio.col.warning": "Nearing the floor",
    "gov_sa.nitaqat.ratio.col.source": "Computed by",
    "gov_sa.nitaqat.ratio.stat.warnings": "Times the ratio neared a floor",
    "gov_sa.nitaqat.ratio.action.refresh": "Refresh from HR",
    "gov_sa.nitaqat.ratio.action.compute": "Compute now",
    "gov_sa.nitaqat.ratio.action.settings": "Warning margin",
    "gov_sa.nitaqat.ratio.field.warning_margin": "Warn within this many points of the band's floor",
    "gov_sa.nitaqat.ratio.field.warning_margin.help": "Points of ratio. 2 by default — a setting, not a rule of the authority's.",
    "gov_sa.nitaqat.band.red": "Red",
    "gov_sa.nitaqat.band.low_green": "Low green",
    "gov_sa.nitaqat.band.mid_green": "Mid green",
    "gov_sa.nitaqat.band.high_green": "High green",
    "gov_sa.nitaqat.band.platinum": "Platinum",
    "gov_sa.nitaqat.source.event": "Automatically",
    "gov_sa.nitaqat.source.person": "A person",
    "gov_sa.nitaqat.source.refresh": "A refresh from HR",
    "gov_sa.nitaqat.state.computed": "Computed",
    "gov_sa.nitaqat.state.no_workforce": "Nobody to count",
    "gov_sa.nitaqat.state.not_configured": "Not configured",
    "gov_sa.nitaqat.threshold_status.unconfirmed": "Unconfirmed",
    "gov_sa.nitaqat.threshold_status.confirmed": "Confirmed",
    "gov_sa.nitaqat.threshold_status.retired": "Retired",
    "gov_sa.nitaqat.thresholds.col.from_on": "From",
    "gov_sa.nitaqat.thresholds.col.status": "Status",
    "gov_sa.nitaqat.thresholds.col.in_force": "In force",
    "gov_sa.nitaqat.thresholds.col.confirmed_by": "Confirmed by",
    "gov_sa.nitaqat.thresholds.col.can_confirm": "You may confirm this",
    "gov_sa.nitaqat.thresholds.col.can_retire": "You may retire this",
    "gov_sa.nitaqat.thresholds.stat.unconfirmed": "Waiting to be confirmed",
    "gov_sa.nitaqat.thresholds.action.confirm": "Confirm against the authority's text",
    "gov_sa.nitaqat.thresholds.action.retire": "Retire",
    "gov_sa.nitaqat.minimum_wages.screen.title": "Nitaqat minimum wage",
    "gov_sa.nitaqat.minimum_wages.screen.lede": "The wage a citizen must be registered at to count, from a day, confirmed by somebody else ⚠ — no figure is assumed.",
    "gov_sa.nitaqat.minimum_wages.col.amount": "Minimum wage",
    "gov_sa.nitaqat.minimum_wages.action.add": "Enter a minimum wage",
    "gov_sa.nitaqat.minimum_wages.field.amount": "Minimum wage (SAR)",
    "gov_sa.nitaqat.minimum_wages.field.amount.help": "As the authority's text states it for counting a citizen. Somebody else confirms it before it serves.",
    "gov_sa.nitaqat.bands.screen.title": "Nitaqat bands",
    "gov_sa.nitaqat.bands.screen.lede": "Where each band starts for this establishment's activity and size, from a day, confirmed by somebody else ⚠ — no limit is assumed.",
    "gov_sa.nitaqat.bands.col.band": "Band",
    "gov_sa.nitaqat.bands.col.min_ratio": "Starts at (%)",
    "gov_sa.nitaqat.bands.action.add": "Enter a band",
    "gov_sa.nitaqat.bands.action.confirm": "Confirm against the authority's table",
    "gov_sa.nitaqat.bands.field.min_ratio.help": "The lowest ratio in this band, as the authority's table gives it. Somebody else confirms it before it serves.",
    "gov_sa.nitaqat.establishment.title": "Nitaqat (Saudization)",
    "gov_sa.nitaqat.establishment.col.state": "Computed",
    "gov_sa.nitaqat.establishment.col.ratio": "Saudization ratio",
    "gov_sa.nitaqat.establishment.col.band": "Band",
    "gov_sa.nitaqat.establishment.col.next_band": "Next band",
    "gov_sa.nitaqat.establishment.col.next_min_ratio": "Next band from",
    "gov_sa.nitaqat.establishment.col.gap": "Above the band's floor",
    "gov_sa.nitaqat.establishment.col.saudis_counted": "Citizens counted",
    "gov_sa.nitaqat.establishment.col.non_saudis": "Non-citizens",
    "gov_sa.nitaqat.establishment.col.saudis_total": "Citizens in service",
    "gov_sa.nitaqat.establishment.col.warning": "Nearing the floor",
    "gov_sa.nitaqat.establishment.link": "Nitaqat",
    "gov_sa.nitaqat.establishment.warning.title": "Nitaqat warning",
    "gov_sa.nitaqat.establishment.alert.warning": "The Saudization ratio is within {gap} points of the {band} band's floor",
    "gov_sa.nitaqat.establishment.note": "Computed from what employees, GOSI and Qiwa published, against the minimum wage and the band floors confirmed as settings — ⚠ confirm every figure with the authority. Not computed until a minimum wage and bands are confirmed and in force.",
    "gov_sa.nitaqat.ratio_words": "{value}%",
    "gov_sa.nitaqat.gap_words": "{gap} points",
    "gov_sa.nitaqat.counted_words": "{saudis_counted} of {saudis_total}",
    "gov_sa.refusal.nitaqat.not_configured": "No confirmed minimum wage or bands are in force: nothing is computed yet.",
    "gov_sa.refusal.nitaqat.amount": "The minimum wage is more than zero.",
    "gov_sa.refusal.nitaqat.date_taken": "A row from {from_on} is already entered; retire it first.",
    "gov_sa.refusal.nitaqat.retired": "This threshold is retired.",
    "gov_sa.refusal.nitaqat.already_confirmed": "Already confirmed.",
    "gov_sa.refusal.nitaqat.own_entry": "Whoever entered a threshold does not confirm it; somebody else does.",
};
export const GOV_SA_AR = {
    // ── gov-sa/qiwa: the labour-platform worklist (#61) ──
    "nav.module.qiwa": "قوى",
    "nav.qiwa.worklist": "مهام قوى",
    "gov_sa.qiwa.worklist.screen.title": "مهام قوى",
    "gov_sa.qiwa.worklist.screen.lede": "ما يُنفَّذ في قوى من العقود ونقل الخدمات، يُسجَّل هنا ويراجعه غيرك.",
    "gov_sa.qiwa.worklist.col.employee": "الموظّف",
    "gov_sa.qiwa.worklist.col.employee_number": "الرقم الوظيفي",
    "gov_sa.qiwa.worklist.col.kind": "المطلوب",
    "gov_sa.qiwa.worklist.col.effective_on": "من تاريخ",
    "gov_sa.qiwa.worklist.col.days_since": "منذ (أيام)",
    "gov_sa.qiwa.worklist.col.status": "الحالة",
    "gov_sa.qiwa.worklist.col.reference": "مرجع قوى",
    "gov_sa.qiwa.worklist.col.last_failure": "رفض المنصّة",
    "gov_sa.qiwa.worklist.col.failed_on": "تاريخ الرفض",
    "gov_sa.qiwa.worklist.col.transfer_from": "منقول من",
    "gov_sa.qiwa.worklist.col.can_refuse": "يمكنك تسجيل رفض",
    "gov_sa.qiwa.worklist.col.done_on": "تاريخ التنفيذ",
    "gov_sa.qiwa.worklist.col.contract_version": "إصدار العقد",
    "gov_sa.qiwa.worklist.col.recorded_by_me": "سجّلتَه أنت",
    "gov_sa.qiwa.worklist.col.about_me": "يخصّك",
    "gov_sa.qiwa.worklist.col.employment_id": "التوظيف",
    "gov_sa.qiwa.worklist.col.can_record": "يمكنك تسجيله",
    "gov_sa.qiwa.worklist.col.can_check": "يمكنك مراجعته",
    "gov_sa.qiwa.worklist.col.can_send_back": "يمكنك إعادته",
    "gov_sa.qiwa.worklist.col.can_withdraw": "يمكنك سحبه",
    "gov_sa.qiwa.kind.attest_contract": "توثيق العقد",
    "gov_sa.qiwa.kind.update_contract": "تحديث العقد",
    "gov_sa.qiwa.kind.end_relation": "إنهاء العلاقة التعاقدية",
    "gov_sa.qiwa.kind.transfer_service": "نقل الخدمات",
    "gov_sa.qiwa.kind.verify_employee": "التحقق من بيانات الموظّف",
    "gov_sa.qiwa.status.to_do": "للتنفيذ",
    "gov_sa.qiwa.status.recorded": "بانتظار المراجعة",
    "gov_sa.qiwa.status.done": "مُنجز",
    "gov_sa.qiwa.status.withdrawn": "مسحوب",
    "gov_sa.qiwa.worklist.stat.open": "للتنفيذ في قوى",
    "gov_sa.qiwa.worklist.stat.recorded": "بانتظار المراجعة",
    "gov_sa.qiwa.worklist.action.refresh": "تحديث من الموارد البشرية",
    "gov_sa.qiwa.worklist.action.open_transfer": "فتح نقل خدمات",
    "gov_sa.qiwa.worklist.action.open_transfer.field.employment_id.help": "كلّ من لا يُعرف أنه مواطن. حدّث من الموارد البشرية إن لم يظهر الشخص.",
    "gov_sa.qiwa.worklist.action.open_transfer.field.transfer_from.help": "المنشأة التي تنتقل منها الخدمات، كما تسمّيها المنصّة.",
    "gov_sa.qiwa.worklist.action.refused": "رفضته المنصّة",
    "gov_sa.qiwa.worklist.action.refused.field.reason": "ما قالته المنصّة",
    "gov_sa.qiwa.channel.not_configured": "منصّة قوى غير متّصلة: لم تُزوَّد بعد بالإعدادات التي تمنحها الجهة.",
    "gov_sa.qiwa.channel.no_adapter": "منصّة قوى غير متّصلة بعد: لم يُجهَّز الربط مع قوى.",
    "gov_sa.muqeem.channel.not_configured": "منصّة مقيم غير متّصلة: لم تُزوَّد بعد بالإعدادات التي تمنحها الجهة.",
    "gov_sa.muqeem.channel.no_adapter": "منصّة مقيم غير متّصلة بعد: لم يُجهَّز الربط مع مقيم.",
    "gov_sa.qiwa.worklist.action.record": "تسجيل مرجع قوى",
    "gov_sa.qiwa.worklist.action.record.field.reference.help": "الرقم الذي أعطته المنصّة للعملية. يراجعه شخص آخر قبل أن يُعتدّ به.",
    "gov_sa.qiwa.worklist.action.check": "روجع في قوى",
    "gov_sa.qiwa.worklist.action.send_back": "إعادة للتصحيح",
    "gov_sa.qiwa.worklist.action.withdraw": "لا يلزم إجراء",
    "gov_sa.refusal.qiwa.item_not_open": "لا يُعدّل هكذا إلا بند لم يُنفَّذ بعد (هذا {status}).",
    "gov_sa.refusal.qiwa.item_not_recorded": "لا يُراجَع أو يُعاد إلا بند مسجَّل (هذا {status}).",
    "gov_sa.refusal.qiwa.own_record": "من سجّله لا يراجعه؛ يراجعه غيره.",
    "gov_sa.refusal.qiwa.about_self": "هذا يخصّ توظيفك أنت؛ يقرّره غيرك.",
    "gov_sa.refusal.qiwa.subject_unknown": "لم يُعرف هنا بعدُ مَن يخصّه هذا، فلا يُتحقّق أنه ليس أنت. حدّث من الموارد البشرية أولاً.",
    "gov_sa.refusal.qiwa.employment_unknown": "هذا الموظّف غير معروف هنا بعد. حدّث من الموارد البشرية أولًا.",
    "gov_sa.refusal.qiwa.citizen_transfer": "لا تُنقل خدمات المواطن من هذه القائمة.",
    "gov_sa.refusal.qiwa.transfer_open": "يوجد نقل خدمات مفتوح لهذا الموظّف.",
    "gov_sa.refusal.qiwa.not_connected": "منصّة قوى غير متّصلة، فلم يُرسَل شيء. نفّذه في المنصّة وسجّل مرجعها.",
    // ── gov-sa/mudad: the payroll run's WPS page and card (WPS decision: mudad owns the bank file) ──
    "gov_sa.mudad.run.title": "مسيّر الرواتب (حماية الأجور)",
    "gov_sa.mudad.run.col.period": "فترة المسيّر",
    "gov_sa.mudad.run.col.kind": "نوع المسيّر",
    "gov_sa.mudad.run.col.status": "حالة المسيّر",
    "gov_sa.mudad.run.col.salary_file": "ملف حماية الأجور",
    "gov_sa.mudad.run.col.pay_date": "يوم الصرف",
    "gov_sa.mudad.run.col.due_on": "يُرفع إلى مُدد قبل",
    "gov_sa.mudad.run.col.stage": "مهلة حماية الأجور",
    "gov_sa.mudad.run.col.employees": "الموظّفون",
    "gov_sa.mudad.run.col.hr_state": "أجابت الرواتب",
    "gov_sa.mudad.run.kind.main": "رئيسية",
    "gov_sa.mudad.run.kind.supplementary": "تكميلية",
    "gov_sa.mudad.run.kind.settlement": "تسوية نهائية",
    "gov_sa.mudad.run.status.approved": "معتمدة",
    "gov_sa.mudad.run.status.paid": "مصروفة",
    "gov_sa.mudad.run.status.locked": "مقفلة",
    "gov_sa.mudad.run.salary_file.not_generated": "لم يُنشأ الملف بعد",
    "gov_sa.mudad.run.salary_file.generated": "أُنشئ ولم يُرفع",
    "gov_sa.mudad.run.salary_file.uploaded": "رُفع إلى مُدد",
    "gov_sa.mudad.run.salary_file.status_imported": "استُورد تقرير الحالة",
    "gov_sa.mudad.run.title_template": "مسيّر {period} في مُدد",
    "gov_sa.mudad.run.subtitle.pay_date": "صُرفت في {value}",
    "gov_sa.mudad.run.subtitle.employees": "{value} موظّفاً",
    "gov_sa.mudad.run.monogram": "حأ",
    "gov_sa.mudad.run.alert.overdue": "ملف حماية الأجور لهذا المسيّر تجاوز مهلة الرفع ({stage})",
    "gov_sa.mudad.run.alert.due": "ارفع ملف حماية الأجور إلى مُدد قبل {due_on}",
    "gov_sa.mudad.run.alert.hr_silent": "لم تُجب الرواتب: المعروض آخر ما وصل إلى مُدد عن هذا المسيّر، لا سطر الرواتب نفسه",
    "gov_sa.mudad.run_wps.title": "حماية الأجور (مُدد)",
    "gov_sa.mudad.run_wps.col.salary_file": "ملف حماية الأجور",
    "gov_sa.mudad.run_wps.col.salary_filename": "الملف",
    "gov_sa.mudad.run_wps.col.direct_file": "قائمة التحويل المباشر",
    "gov_sa.mudad.run_wps.col.due_on": "يُرفع إلى مُدد قبل",
    "gov_sa.mudad.run_wps.col.days_left": "الأيام المتبقية",
    "gov_sa.mudad.run_wps.col.stage": "مهلة حماية الأجور",
    "gov_sa.mudad.run_wps.col.exposure": "الغرامة إن بقي متأخراً",
    "gov_sa.mudad.run_wps.col.paid": "مدفوع بحسب تقرير مُدد",
    "gov_sa.mudad.run_wps.col.rejected": "مرفوض",
    "gov_sa.mudad.run_wps.col.pending": "قيد المعالجة",
    "gov_sa.mudad.run_wps.col.settlements": "تسويات نهائية صُرفت بهذا المسيّر",
    "gov_sa.mudad.run_wps.link": "ملفات حماية الأجور",
    "gov_sa.mudad.run_wps.note": "يُنشأ الملف ويُرفع ويُستورد تقريره من شاشة ملفات حماية الأجور. لا شيء هنا يتّصل بمُدد أو بالبنك.",
    // ── gov-sa/muqeem: residences and visas (#62) ──
    "nav.module.muqeem": "مقيم",
    "nav.muqeem.worklist": "التأشيرات (مقيم)",
    "nav.muqeem.residences": "الإقامات",
    "gov_sa.muqeem.worklist.screen.title": "التأشيرات (مقيم)",
    "gov_sa.muqeem.worklist.screen.lede": "ما يُنجز في مقيم من التأشيرات ونقل الخدمات، يُسجَّل هنا ويراجعه غيرك.",
    "gov_sa.muqeem.worklist.col.employee": "الموظّف",
    "gov_sa.muqeem.worklist.col.employee_number": "الرقم الوظيفي",
    "gov_sa.muqeem.worklist.col.kind": "المطلوب",
    "gov_sa.muqeem.worklist.col.from_on": "الإجازة من",
    "gov_sa.muqeem.worklist.col.to_on": "الإجازة إلى",
    "gov_sa.muqeem.worklist.col.effective_on": "مطلوبة قبل",
    "gov_sa.muqeem.worklist.col.days_until": "الأيام المتبقية",
    "gov_sa.muqeem.worklist.col.status": "الحالة",
    "gov_sa.muqeem.worklist.col.reference": "رقم التأشيرة",
    "gov_sa.muqeem.worklist.col.issued_on": "تاريخ الإصدار",
    "gov_sa.muqeem.worklist.col.valid_until": "صالحة حتى",
    "gov_sa.muqeem.worklist.col.leave_type": "نوع الإجازة",
    "gov_sa.muqeem.worklist.col.transfer_from": "منقولة من",
    "gov_sa.muqeem.worklist.col.recorded_by_me": "سجّلتَها أنت",
    "gov_sa.muqeem.worklist.col.about_me": "تخصّك",
    "gov_sa.muqeem.worklist.col.employment_id": "التوظيف",
    "gov_sa.muqeem.worklist.col.can_record": "يمكنك تسجيلها",
    "gov_sa.muqeem.worklist.col.can_check": "يمكنك مراجعتها",
    "gov_sa.muqeem.worklist.col.can_send_back": "يمكنك إعادتها",
    "gov_sa.muqeem.worklist.col.can_withdraw": "يمكنك سحبها",
    "gov_sa.muqeem.kind.exit_reentry": "خروج وعودة",
    "gov_sa.muqeem.kind.final_exit": "خروج نهائي",
    "gov_sa.muqeem.kind.sponsorship_transfer": "نقل خدمات",
    "gov_sa.muqeem.status.waiting": "الجنسية غير معروفة بعد",
    "gov_sa.muqeem.status.to_do": "للاستخراج",
    "gov_sa.muqeem.status.recorded": "بانتظار المراجعة",
    "gov_sa.muqeem.status.done": "مُنجزة",
    "gov_sa.muqeem.status.withdrawn": "مسحوبة",
    "gov_sa.muqeem.worklist.stat.to_do": "تأشيرات للاستخراج",
    "gov_sa.muqeem.worklist.stat.recorded": "بانتظار المراجعة",
    "gov_sa.muqeem.worklist.stat.waiting": "الجنسية غير معروفة بعد",
    "gov_sa.muqeem.worklist.action.refresh": "تحديث من الموارد البشرية",
    "gov_sa.muqeem.worklist.action.open_transfer": "فتح نقل خدمات",
    "gov_sa.muqeem.worklist.action.open_transfer.field.employment_id.help": "كلّ من لا يُعرف أنه مواطن. حدّث من الموارد البشرية إن لم يظهر الشخص.",
    "gov_sa.muqeem.worklist.action.open_transfer.field.transfer_from.help": "المنشأة التي تنتقل منها الخدمات، كما تسمّيها المنصّة.",
    "gov_sa.muqeem.worklist.action.record": "تسجيل التأشيرة",
    "gov_sa.muqeem.worklist.action.record.field.reference.help": "الرقم الذي أعطته المنصّة للتأشيرة. يراجعه شخص آخر قبل أن يُعتدّ به.",
    "gov_sa.muqeem.worklist.action.check": "روجعت في مقيم",
    "gov_sa.muqeem.worklist.action.send_back": "إعادة للتصحيح",
    "gov_sa.muqeem.worklist.action.withdraw": "لا تلزم تأشيرة",
    "gov_sa.muqeem.residences.screen.title": "الإقامات",
    "gov_sa.muqeem.residences.screen.lede": "إقامة كل غير مواطن، برقمها من الموارد البشرية وانتهائها من آخر وثيقة مجدّدة.",
    "gov_sa.muqeem.residences.col.employee": "الموظّف",
    "gov_sa.muqeem.residences.col.employee_number": "الرقم الوظيفي",
    "gov_sa.muqeem.residences.col.residence_number": "رقم الإقامة",
    "gov_sa.muqeem.residences.col.expires_on": "تنتهي في",
    "gov_sa.muqeem.residences.col.days_left": "الأيام المتبقية",
    "gov_sa.muqeem.residences.col.standing": "الوضع",
    "gov_sa.muqeem.residences.col.renewed_on": "جُدّدت في",
    "gov_sa.muqeem.residences.col.employment_status": "حالة التوظيف",
    "gov_sa.muqeem.residences.col.employment_id": "التوظيف",
    "gov_sa.muqeem.residences.col.document_id": "الوثيقة",
    "gov_sa.muqeem.standing.valid": "سارية",
    "gov_sa.muqeem.standing.expiring": "قاربت الانتهاء",
    "gov_sa.muqeem.standing.expired": "منتهية",
    "gov_sa.muqeem.standing.unknown": "الانتهاء غير معروف",
    "gov_sa.muqeem.residences.stat.expiring": "قاربت الانتهاء",
    "gov_sa.muqeem.residences.stat.expired": "منتهية",
    "gov_sa.muqeem.residences.stat.unknown": "الانتهاء غير معروف",
    "gov_sa.muqeem.residences.action.settings": "إعدادات الإقامات",
    "gov_sa.muqeem.residences.field.residence_type_keys": "أنواع الوثائق التي تُعدّ إقامة",
    "gov_sa.muqeem.residences.field.residence_type_keys.help": "مفاتيح أنواع الوثائق في الدليل مفصولة بفواصل — كما كتبتها مساحة العمل (iqama وresidence_permit وresidence افتراضياً).",
    "gov_sa.muqeem.residences.field.expiry_warning_days": "التنبيه قبل الانتهاء بـ (أيام)",
    "gov_sa.muqeem.residences.field.expiry_warning_days.help": "فارغاً يُبقي القيمة الحالية (90 افتراضياً).",
    "gov_sa.refusal.muqeem.item_not_open": "لا تُعدّل هكذا إلا تأشيرة لم تُستخرج بعد (هذه {status}).",
    "gov_sa.refusal.muqeem.item_not_recorded": "لا تُراجَع أو تُعاد إلا تأشيرة مسجَّلة (هذه {status}).",
    "gov_sa.refusal.muqeem.own_record": "من سجّلها لا يراجعها؛ يراجعها غيره.",
    "gov_sa.refusal.muqeem.about_self": "هذه تخصّ توظيفك أنت؛ يقرّرها غيرك.",
    "gov_sa.refusal.muqeem.subject_unknown": "لم يُعرف هنا بعدُ مَن تخصّه هذه، فلا يُتحقّق أنه ليس أنت. حدّث من الموارد البشرية أولاً.",
    "gov_sa.refusal.muqeem.employment_unknown": "هذا الموظّف غير معروف هنا بعد. حدّث من الموارد البشرية أولًا.",
    "gov_sa.refusal.muqeem.citizen_no_sponsor": "المواطن ليس له كفيل يُنقل.",
    "gov_sa.refusal.muqeem.transfer_open": "يوجد نقل خدمات مفتوح لهذا الموظّف.",
    "gov_sa.refusal.muqeem.valid_before_issued": "لا تكون التأشيرة صالحة قبل يوم إصدارها ({issued_on}).",
    "gov_sa.refusal.muqeem.type_key": "مفتاح نوع الوثيقة حروف لاتينية صغيرة وأرقام ونقطة وشرطة وشرطة سفلية ({key}).",
    // ── gov-sa/nitaqat: the Saudization ratio (#63) ──
    "nav.module.nitaqat": "نطاقات",
    "nav.nitaqat.ratio": "نسبة التوطين",
    "nav.nitaqat.minimum_wages": "الحد الأدنى للأجر (نطاقات)",
    "nav.nitaqat.bands": "نطاقات التوطين",
    "gov_sa.nitaqat.ratio.screen.title": "نسبة التوطين",
    "gov_sa.nitaqat.ratio.screen.lede": "نسبة التوطين كلما تحرّكت، الأحدث أولاً، مع النطاق؛ والحدود إعدادات ⚠ تُؤكَّد مع الجهة.",
    "gov_sa.nitaqat.ratio.col.as_of": "بتاريخ",
    "gov_sa.nitaqat.ratio.col.computed_at": "وقت الحساب",
    "gov_sa.nitaqat.ratio.col.ratio": "النسبة",
    "gov_sa.nitaqat.ratio.col.band": "النطاق",
    "gov_sa.nitaqat.ratio.col.gap": "فوق حدّ النطاق",
    "gov_sa.nitaqat.ratio.col.next_band": "النطاق التالي",
    "gov_sa.nitaqat.ratio.col.next_min_ratio": "النطاق التالي من",
    "gov_sa.nitaqat.ratio.col.saudis_counted": "مواطنون محتسبون",
    "gov_sa.nitaqat.ratio.col.saudis_total": "مواطنون على رأس العمل",
    "gov_sa.nitaqat.ratio.col.non_saudis": "غير مواطنين",
    "gov_sa.nitaqat.ratio.col.saudis_below_wage": "دون الحد الأدنى للأجر",
    "gov_sa.nitaqat.ratio.col.saudis_unregistered": "غير مسجَّلين في التأمينات",
    "gov_sa.nitaqat.ratio.col.saudis_unattested": "عقد غير موثَّق",
    "gov_sa.nitaqat.ratio.col.unknown_citizenship": "الجنسية غير معروفة",
    "gov_sa.nitaqat.ratio.col.minimum_wage": "الحد الأدنى المطبَّق",
    "gov_sa.nitaqat.ratio.col.warning": "قريب من حدّ النطاق",
    "gov_sa.nitaqat.ratio.col.source": "حُسبت بواسطة",
    "gov_sa.nitaqat.ratio.stat.warnings": "مرّات اقتراب النسبة من حدّ",
    "gov_sa.nitaqat.ratio.action.refresh": "تحديث من الموارد البشرية",
    "gov_sa.nitaqat.ratio.action.compute": "احسب الآن",
    "gov_sa.nitaqat.ratio.action.settings": "هامش التنبيه",
    "gov_sa.nitaqat.ratio.field.warning_margin": "نبّه عند الاقتراب من حدّ النطاق بهذه النقاط",
    "gov_sa.nitaqat.ratio.field.warning_margin.help": "نقاط من النسبة. 2 افتراضياً — إعداد، لا قاعدة من الجهة.",
    "gov_sa.nitaqat.band.red": "أحمر",
    "gov_sa.nitaqat.band.low_green": "أخضر منخفض",
    "gov_sa.nitaqat.band.mid_green": "أخضر متوسط",
    "gov_sa.nitaqat.band.high_green": "أخضر مرتفع",
    "gov_sa.nitaqat.band.platinum": "بلاتيني",
    "gov_sa.nitaqat.source.event": "تلقائياً",
    "gov_sa.nitaqat.source.person": "شخص",
    "gov_sa.nitaqat.source.refresh": "تحديث من الموارد البشرية",
    "gov_sa.nitaqat.state.computed": "محسوبة",
    "gov_sa.nitaqat.state.no_workforce": "لا أحد يُحتسب",
    "gov_sa.nitaqat.state.not_configured": "غير مهيّأة",
    "gov_sa.nitaqat.threshold_status.unconfirmed": "غير مؤكَّد",
    "gov_sa.nitaqat.threshold_status.confirmed": "مؤكَّد",
    "gov_sa.nitaqat.threshold_status.retired": "موقوف",
    "gov_sa.nitaqat.thresholds.col.from_on": "من تاريخ",
    "gov_sa.nitaqat.thresholds.col.status": "الحالة",
    "gov_sa.nitaqat.thresholds.col.in_force": "ساري",
    "gov_sa.nitaqat.thresholds.col.confirmed_by": "أكّده",
    "gov_sa.nitaqat.thresholds.col.can_confirm": "يمكنك تأكيده",
    "gov_sa.nitaqat.thresholds.col.can_retire": "يمكنك إيقافه",
    "gov_sa.nitaqat.thresholds.stat.unconfirmed": "بانتظار التأكيد",
    "gov_sa.nitaqat.thresholds.action.confirm": "تأكيد مطابقةً لنصّ الجهة",
    "gov_sa.nitaqat.thresholds.action.retire": "إيقاف",
    "gov_sa.nitaqat.minimum_wages.screen.title": "الحد الأدنى للأجر (نطاقات)",
    "gov_sa.nitaqat.minimum_wages.screen.lede": "الأجر الذي يُحتسب به المواطن من تاريخه، ويؤكّده شخص آخر ⚠ ولا رقم مفترض.",
    "gov_sa.nitaqat.minimum_wages.col.amount": "الحد الأدنى للأجر",
    "gov_sa.nitaqat.minimum_wages.action.add": "إدخال حدّ أدنى",
    "gov_sa.nitaqat.minimum_wages.field.amount": "الحد الأدنى للأجر (ريال)",
    "gov_sa.nitaqat.minimum_wages.field.amount.help": "كما ينصّ عليه نصّ الجهة لاحتساب المواطن. يؤكّده شخص آخر قبل أن يسري.",
    "gov_sa.nitaqat.bands.screen.title": "نطاقات التوطين",
    "gov_sa.nitaqat.bands.screen.lede": "بداية كل نطاق لنشاط المنشأة وحجمها من تاريخه، ويؤكّدها شخص آخر ⚠ ولا حدّ مفترض.",
    "gov_sa.nitaqat.bands.col.band": "النطاق",
    "gov_sa.nitaqat.bands.col.min_ratio": "يبدأ عند (%)",
    "gov_sa.nitaqat.bands.action.add": "إدخال نطاق",
    "gov_sa.nitaqat.bands.action.confirm": "تأكيد مطابقةً لجدول الجهة",
    "gov_sa.nitaqat.bands.field.min_ratio.help": "أدنى نسبة في هذا النطاق كما يعطيها جدول الجهة. يؤكّدها شخص آخر قبل أن تسري.",
    "gov_sa.nitaqat.establishment.title": "نطاقات التوطين",
    "gov_sa.nitaqat.establishment.col.state": "الحساب",
    "gov_sa.nitaqat.establishment.col.ratio": "نسبة التوطين",
    "gov_sa.nitaqat.establishment.col.band": "النطاق",
    "gov_sa.nitaqat.establishment.col.next_band": "النطاق التالي",
    "gov_sa.nitaqat.establishment.col.next_min_ratio": "النطاق التالي من",
    "gov_sa.nitaqat.establishment.col.gap": "فوق حدّ النطاق",
    "gov_sa.nitaqat.establishment.col.saudis_counted": "مواطنون محتسبون",
    "gov_sa.nitaqat.establishment.col.non_saudis": "غير مواطنين",
    "gov_sa.nitaqat.establishment.col.saudis_total": "مواطنون على رأس العمل",
    "gov_sa.nitaqat.establishment.col.warning": "قريب من حدّ النطاق",
    "gov_sa.nitaqat.establishment.link": "نطاقات",
    "gov_sa.nitaqat.establishment.warning.title": "تنبيه نطاقات",
    "gov_sa.nitaqat.establishment.alert.warning": "نسبة التوطين على بُعد {gap} نقطة من حدّ نطاق {band}",
    "gov_sa.nitaqat.establishment.note": "محسوبة من بيانات شؤون الموظّفين والتأمينات وقوى، أمام الحد الأدنى للأجر وحدود النطاقات المؤكَّدة كإعدادات — ⚠ أكّد كل رقم مع الجهة. لا تُحسب حتى يُؤكَّد حدّ أدنى ونطاقات وتسري.",
    "gov_sa.nitaqat.ratio_words": "{value}%",
    "gov_sa.nitaqat.gap_words": "{gap} نقطة",
    "gov_sa.nitaqat.counted_words": "{saudis_counted} من {saudis_total}",
    "gov_sa.refusal.nitaqat.not_configured": "لا حدّ أدنى أو نطاقات مؤكَّدة سارية: لم يُحسب شيء بعد.",
    "gov_sa.refusal.nitaqat.amount": "الحد الأدنى للأجر أكبر من صفر.",
    "gov_sa.refusal.nitaqat.date_taken": "صفّ من {from_on} مُدخل أصلاً؛ أوقفه أولاً.",
    "gov_sa.refusal.nitaqat.retired": "هذا الحدّ موقوف.",
    "gov_sa.refusal.nitaqat.already_confirmed": "مؤكَّد أصلاً.",
    "gov_sa.refusal.nitaqat.own_entry": "من أدخل الحدّ لا يؤكّده؛ يؤكّده غيره.",
};
//# sourceMappingURL=i18n-gov-sa.js.map